import styled from "styled-components";

const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
`;

export default Column;
